import React from 'react';
import { ScorecardLabel } from '../../../../containers/applicant_tracking/InterviewKits/InterviewKitPage/ScorecardBody/ScorecardLabel';
import { ScorecardAttributeValue } from '../../../../containers/applicant_tracking/Scorecards/ScorecardPage/ScorecardBody/RatingSection/ScorecardAttribute/ScorecardAttributeValue';
import { Section } from '../../../../entities/v1/survey_engine/Section';
import { Question } from '../../../../entities/v1/survey_engine/Question';
import { Chip, ChipColor } from '../../../Chip';
import classNames from 'classnames';

interface PropTypes {
  section: Section;
  showFieldLabels?: boolean;
  preview?: boolean;
}

export function RatingSection(props: PropTypes) {
  const className = props.preview
    ? 'border border-blue-gray-200 rounded-2 pt-4h pb-3h px-4'
    : 'd-flex gap-3 flex-wrap';

  return (
    <div className='w-100'>
      <ScorecardLabel
        classNames={classNames('mb-4')}
        title={props.section.name}
        label='1-5 Scale Rating'
        showFieldLabels={props.preview}
      />
      <div className={className}>
        {props.section.questions.map((question: Question) => {
          return props.preview ? (
            <div
              key={question.id}
              className='d-flex flex-column gap-2 w-100 mb-2'
            >
              <ScorecardAttributeValue
                key={question.id}
                id={`${question.id}`}
                rating={5}
                editable={false}
                name={question.title}
                fillColorClass='text-blue-gray-500'
                preview={props.preview}
              />
            </div>
          ) : (
            <Chip key={question.id} color={ChipColor.BlueLight} truncate>
              {question.title}
            </Chip>
          );
        })}
      </div>
    </div>
  );
}
